import { render, staticRenderFns } from "./activity-review.vue?vue&type=template&id=7dd10fde&scoped=true&"
import script from "./activity-review.vue?vue&type=script&lang=js&"
export * from "./activity-review.vue?vue&type=script&lang=js&"
import style0 from "./activity-review.vue?vue&type=style&index=0&id=7dd10fde&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd10fde",
  null
  
)

component.options.__file = "activity-review.vue"
export default component.exports